import React from "react";
import { connect } from "react-redux";
import ReactEcharts from "echarts-for-react";
import {reviewBarChartOption} from "../../Data/Charts";
import "echarts-gl";
class CustomerReviewBarChart extends React.Component {
  componentDidMount() {

  }
  componentDidUpdate(prevProps:Readonly<P>, prevState:Readonly<S>, snapshot:SS) {
    if (prevProps.customerReviewsData !== this.props.customerReviewsData) {
      this.chartPlace();
    }
  }
  chartPlace = () => {
    const { customerReviewsData } = this.props;
    if (customerReviewsData.length === 0) return [];

    const labels = customerReviewsData.map((_, index) => `Bar ${index + 1}`); // Barların altına bir şey yazmaması için sahte label kullanıldı
    const data = customerReviewsData.map(item => ({
      name: item.customer_name,
      type: item.type,
      review: item.review
    }));
    return {
      labels,
      data
    };
  };
  render() {

    const { labels, data } = this.chartPlace();

    const option = reviewBarChartOption(labels, data);

    return (
        <ReactEcharts
            option={option}
            opts={{ renderer: 'svg' }}
            style={{ height: '300px', width: '100%' }}
        />

    );
  }
}

const mapStateToProps = (state) => ({
  customerReviewsData: state.analyticalReducer.customerReviewsData,
});

export default connect(mapStateToProps, {})(CustomerReviewBarChart);
